import "./Inquire.module.css";
import Header from "@/reusable_sections/Header";
import StartTheMagic from "./sections/StartTheMagic";
import CommonInquiries from "./sections/CommonInquiries";
import MainSiteFooter from "@/reusable_sections/Footer";
export default function InquirePage() {
  return <div>
      <Header />
      <StartTheMagic />
      <CommonInquiries />
      <MainSiteFooter />
    </div>;
}